export enum JobCardSubtitleType {
  Details,
  HeadlineStatus,
  Created,
  Due
}
